module.exports = __webpack_public_path__ + "static/bentonsanscond-medium-webfont-6d97e20a79fc7a120f4e3011b5d934e1.woff";